import { useMemo } from 'react';
import { ROUTES } from '../../../routes/constants';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Home } from '../../../assets/svg/icons/home.svg';
import { ReactComponent as Calendar } from '../../../assets/svg/icons/calendario.svg';
import { ReactComponent as Barber_pole } from '../../../assets/svg/icons/barber_pole.svg';
import { ReactComponent as Message } from '../../../assets/svg/icons/messaggi.svg';
import { ReactComponent as Bell } from '../../../assets/svg/icons/campanella.svg';
import { ReactComponent as Statistics } from '../../../assets/svg/icons/statistiche.svg';
import { ReactComponent as Shop } from '../../../assets/svg/icons/shop.svg';
import { ReactComponent as Settings } from '../../../assets/svg/icons/impostazioni.svg';
import { ReactComponent as Client } from '../../../assets/svg/icons/profilo.svg';
import { ReactComponent as Payment } from '../../../assets/svg/icons/portafogli.svg';
import { ReactComponent as Reviews } from '../../../assets/svg/icons/stella.svg';
import { ReactComponent as Expenses } from '../../../assets/svg/icons/receipt_text.svg';
import { ReactComponent as Advertising } from '../../../assets/svg/icons/annuncio.svg';

const ICON = {
  home: <Home />,
  calendar: <Calendar />,
  salon: <Barber_pole />,
  clients: <Client />,
  payments: <Payment />,
  shop: <Shop />,
  statistics: <Statistics />,
  expenses: <Expenses />,
  reviews: <Reviews />,
  advertising: <Advertising />,
  communications: <Message />,
  notifications: <Bell />,
  settings: <Settings />,
};

export const useNavBarRoutes = () => {
  const { t, i18n } = useTranslation();

  return useMemo(
    () => [
      {
        title: '',
        items: [
          {
            label: t('sideBar.navigation.home'),
            link: ROUTES.HOME,
            icon: ICON.home,
            newTab: false,
            languages: ['it', 'en', 'fr'],
            showNewBadge: true,
          },
          {
            label: t('sideBar.navigation.calendar'),
            link: ROUTES.SCHEDULER,
            icon: ICON.calendar,
            newTab: false,
            languages: ['it', 'en', 'fr'],
          },
        ],
      },
      {
        title: t('sideBar.groups.salon'),
        items: [
          {
            label: t('sideBar.navigation.salonManagement'),
            link: ROUTES.SALON_MANAGEMENT,
            icon: ICON.salon,
            newTab: false,
            languages: ['it', 'en', 'fr'],
          },
          {
            icon: ICON.clients,
            label: t('sideBar.navigation.clients'),
            link: `${ROUTES.CLIENTS}`,
            newTab: false,
            languages: ['it', 'en', 'fr'],
          },
          {
            icon: ICON.payments,
            label: t('sideBar.navigation.payments'),
            link: `${ROUTES.PAYMENTS}`,
            newTab: false,
            languages: ['it', 'en', 'fr'],
          },
          {
            label: t('sideBar.navigation.shop'),
            link: ROUTES.SHOP,
            icon: ICON.shop,
            newTab: false,
            languages: ['it'],
          },
        ],
      },
      {
        title: t('sideBar.groups.performance'),
        items: [
          {
            label: t('sideBar.navigation.statistics'),
            link: ROUTES.STATISTICS,
            icon: ICON.statistics,
            newTab: false,
            languages: ['it'],
            showNewBadge: true,
          },
          {
            label: t('sideBar.navigation.expenses'),
            link: `${ROUTES.SETTINGS}${ROUTES.EXPENSES}`,
            icon: ICON.expenses,
            newTab: false,
            languages: ['it', 'en', 'fr'],
            requiresPremium: true,
            // Badge "Novità" visibile solo se sbloccato: su Base resta la fiamma Premium.
            showNewBadge: true,
          },
          {
            icon: ICON.reviews,
            label: t('sideBar.navigation.reviews'),
            link: ROUTES.REVIEWS,
            newTab: false,
            languages: ['it', 'en', 'fr'],
          },
          {
            icon: ICON.advertising,
            label: t('sideBar.navigation.advertising'),
            link: ROUTES.ADVERTISING,
            newTab: false,
            languages: ['it', 'en', 'fr'],
            showNewBadge: true,
          },
          {
            label: t('sideBar.navigation.communications'),
            link: ROUTES.COMMUNICATIONS,
            icon: ICON.communications,
            newTab: false,
            languages: ['it', 'en', 'fr'],
          },
        ],
      },
      {
        title: t('sideBar.groups.account'),
        items: [
          {
            label: t('sideBar.navigation.notifications'),
            link: ROUTES.NOTIFICATION,
            icon: ICON.notifications,
            newTab: false,
            languages: ['it', 'en', 'fr'],
          },
          {
            label: t('sideBar.navigation.settings'),
            link: ROUTES.SETTINGS,
            icon: ICON.settings,
            newTab: false,
            languages: ['it', 'en', 'fr'],
          },
        ],
      },
    ],
    [t, i18n.language],
  );
};
